export enum FundingMaType {
	MA = "MA",
	FUNDING = "FUNDING",
}

export enum FundingRounds {
	GRANT = "grant",
	PRE_SEED = "pre-seed",
	SEED = "seed",
	SERIES_A = "series a",
	SERIES_B = "series b",
	SERIES_C = "series c",
	SERIES_D = "series d",
	SERIES_E = "series e",
	SERIES_F = "series f",
	SERIES_G = "series g",
}

export const FundingRoundsValues = [
	{
		id: FundingRounds.GRANT,
		title: "Grant",
	},
	{
		id: FundingRounds.PRE_SEED,
		title: "Pre-Seed",
	},
	{
		id: FundingRounds.SEED,
		title: "Seed",
	},
	{
		id: FundingRounds.SERIES_A,
		title: "Series A",
	},
	{
		id: FundingRounds.SERIES_B,
		title: "Series B",
	},
	{
		id: FundingRounds.SERIES_C,
		title: "Series C",
	},
	{
		id: FundingRounds.SERIES_D,
		title: "Series D",
	},
	{
		id: FundingRounds.SERIES_E,
		title: "Series E",
	},
	{
		id: FundingRounds.SERIES_F,
		title: "Series F",
	},
	{
		id: FundingRounds.SERIES_G,
		title: "Series G",
	},
];

export const FundingCountries: { id: string; title: string }[] = [
	{ id: "US", title: "United States" },
	{ id: "CN", title: "China" },
	{ id: "JP", title: "Japan" },
	{ id: "DE", title: "Germany" },
	{ id: "GB", title: "United Kingdom" },
	{ id: "IN", title: "India" },
	{ id: "FR", title: "France" },
	{ id: "CA", title: "Canada" },
	{ id: "IT", title: "Italy" },
	{ id: "KR", title: "South Korea" },
	{ id: "AU", title: "Australia" },
	{ id: "BR", title: "Brazil" },
	{ id: "ES", title: "Spain" },
	{ id: "MX", title: "Mexico" },
	{ id: "ID", title: "Indonesia" },
	{ id: "NL", title: "Netherlands" },
	{ id: "SA", title: "Saudi Arabia" },
	{ id: "TR", title: "Turkey" },
	{ id: "CH", title: "Switzerland" },
	{ id: "TW", title: "Taiwan" },
	{ id: "PL", title: "Poland" },
	{ id: "SE", title: "Sweden" },
	{ id: "BE", title: "Belgium" },
	{ id: "TH", title: "Thailand" },
	{ id: "AR", title: "Argentina" },
	{ id: "NG", title: "Nigeria" },
	{ id: "AT", title: "Austria" },
	{ id: "IR", title: "Iran" },
	{ id: "NO", title: "Norway" },
	{ id: "AE", title: "United Arab Emirates" },
	{ id: "IE", title: "Ireland" },
	{ id: "IL", title: "Israel" },
	{ id: "ZA", title: "South Africa" },
	{ id: "DK", title: "Denmark" },
	{ id: "SG", title: "Singapore" },
	{ id: "MY", title: "Malaysia" },
	{ id: "PH", title: "Philippines" },
	{ id: "HK", title: "Hong Kong" },
	{ id: "CO", title: "Colombia" },
	{ id: "BD", title: "Bangladesh" },
	{ id: "EG", title: "Egypt" },
	{ id: "FI", title: "Finland" },
	{ id: "CL", title: "Chile" },
	{ id: "VN", title: "Vietnam" },
	{ id: "CZ", title: "Czechia" },
	{ id: "RO", title: "Romania" },
	{ id: "NZ", title: "New Zealand" },
	{ id: "PT", title: "Portugal" },
	{ id: "GR", title: "Greece" },
	{ id: "IQ", title: "Iraq" },
	{ id: "QA", title: "Qatar" },
	{ id: "PE", title: "Peru" },
	{ id: "HU", title: "Hungary" },
	{ id: "KW", title: "Kuwait" },
	{ id: "UA", title: "Ukraine" },
	{ id: "MA", title: "Morocco" },
	{ id: "SK", title: "Slovakia" },
	{ id: "PR", title: "Puerto Rico" },
	{ id: "EC", title: "Ecuador" },
	{ id: "OM", title: "Oman" },
	{ id: "KE", title: "Kenya" },
	{ id: "LU", title: "Luxembourg" },
	{ id: "CU", title: "Cuba" },
	{ id: "LK", title: "Sri Lanka" },
	{ id: "UZ", title: "Uzbekistan" },
	{ id: "BG", title: "Bulgaria" },
	{ id: "HR", title: "Croatia" },
	{ id: "CI", title: "Côte d'Ivoire" },
	{ id: "BY", title: "Belarus" },
	{ id: "UY", title: "Uruguay" },
	{ id: "PA", title: "Panama" },
	{ id: "SI", title: "Slovenia" },
	{ id: "TM", title: "Turkmenistan" },
	{ id: "LT", title: "Lithuania" },
	{ id: "LB", title: "Lebanon" },
	{ id: "TZ", title: "Tanzania" },
	{ id: "JO", title: "Jordan" },
	{ id: "BH", title: "Bahrain" },
	{ id: "RS", title: "Serbia" },
	{ id: "CM", title: "Cameroon" },
	{ id: "BO", title: "Bolivia" },
	{ id: "PY", title: "Paraguay" },
	{ id: "GH", title: "Ghana" },
	{ id: "EE", title: "Estonia" },
	{ id: "UG", title: "Uganda" },
	{ id: "ZM", title: "Zambia" },
	{ id: "AF", title: "Afghanistan" },
	{ id: "BA", title: "Bosnia and Herzegovina" },
	{ id: "MZ", title: "Mozambique" },
	{ id: "AM", title: "Armenia" },
	{ id: "GE", title: "Georgia" },
	{ id: "HN", title: "Honduras" },
	{ id: "AL", title: "Albania" },
	{ id: "MG", title: "Madagascar" },
	{ id: "NA", title: "Namibia" },
	{ id: "SN", title: "Senegal" },
	{ id: "MT", title: "Malta" },
	{ id: "TD", title: "Chad" },
	{ id: "NE", title: "Niger" },
	{ id: "ML", title: "Mali" },
	{ id: "KG", title: "Kyrgyzstan" },
	{ id: "MW", title: "Malawi" },
	{ id: "RW", title: "Rwanda" },
	{ id: "BI", title: "Burundi" },
	{ id: "KM", title: "Comoros" },
	{ id: "LS", title: "Lesotho" },
	{ id: "TJ", title: "Tajikistan" },
	{ id: "SR", title: "Suriname" },
	{ id: "ME", title: "Montenegro" },
	{ id: "SZ", title: "Eswatini" },
	{ id: "SL", title: "Sierra Leone" },
	{ id: "GM", title: "Gambia" },
	{ id: "GY", title: "Guyana" },
	{ id: "TL", title: "Timor-Leste" },
	{ id: "MR", title: "Mauritania" },
	{ id: "BF", title: "Burkina Faso" },
	{ id: "LR", title: "Liberia" },
	{ id: "CV", title: "Cape Verde" },
	{ id: "MU", title: "Mauritius" },
	{ id: "BT", title: "Bhutan" },
	{ id: "BJ", title: "Benin" },
	{ id: "CF", title: "Central African Republic" },
	{ id: "TG", title: "Togo" },
	{ id: "GN", title: "Guinea" },
	{ id: "GA", title: "Gabon" },
	{ id: "ST", title: "São Tomé and Príncipe" },
	{ id: "GQ", title: "Equatorial Guinea" },
	{ id: "AG", title: "Antigua and Barbuda" },
	{ id: "BZ", title: "Belize" },
	{ id: "BB", title: "Barbados" },
	{ id: "KN", title: "Saint Kitts and Nevis" },
	{ id: "VU", title: "Vanuatu" },
	{ id: "SB", title: "Solomon Islands" },
	{ id: "VC", title: "Saint Vincent and the Grenadines" },
	{ id: "FJ", title: "Fiji" },
	{ id: "WS", title: "Samoa" },
	{ id: "TO", title: "Tonga" },
	{ id: "DM", title: "Dominica" },
	{ id: "RU", title: "Russia" },
];

export const FundingCategories: { id: string; title: string }[] = [
	{ id: "ai", title: "AI" },
	{ id: "saas", title: "SaaS" },
	{ id: "cybersecurity", title: "Cybersecurity" },
	{ id: "web3", title: "Web3" },
	{ id: "devtools", title: "Devtools" },
	{ id: "analytics", title: "Analytics" },
	{ id: "fintech", title: "Fintech" },
	{ id: "ecommerce", title: "E-commerce" },
	{ id: "marketing", title: "Marketing" },
	{ id: "sales", title: "Sales" },
	{ id: "hr tech", title: "HR Tech" },
	{ id: "legal", title: "Legal" },
	{ id: "insurance", title: "Insurance" },
	{ id: "vc & investment", title: "VC & Investment" },
	{ id: "healthcare", title: "Healthcare" },
	{ id: "biotechnology", title: "Biotechnology" },
	{ id: "education", title: "Education" },
	{ id: "real estate", title: "Real Estate" },
	{ id: "energy", title: "Energy" },
	{ id: "logistics", title: "Logistics" },
	{ id: "manufacturing", title: "Manufacturing" },
	{ id: "retail", title: "Retail" },
	{ id: "agriculture", title: "Agriculture" },
	{ id: "aerospace & defense", title: "Aerospace & Defense" },
	{ id: "robotics", title: "Robotics" },
	{ id: "telecommunications", title: "Telecommunications" },
	{ id: "travel", title: "Travel" },
	{ id: "sports", title: "Sports" },
	{ id: "media", title: "Media" },
	{ id: "construction", title: "Construction" },
	{ id: "environmental services", title: "Environmental Services" },
	{ id: "battery technology", title: "Battery Technology" },
	{ id: "arts", title: "Arts" },
	{ id: "architecture", title: "Architecture" },
	{ id: "cosmetics", title: "Cosmetics" },
	{ id: "science", title: "Science" },
	{ id: "non-profit", title: "Non-Profit" },
];

export enum MaStatus {
	ANNOUNCED = "ANNOUNCED",
	COMPLETED = "COMPLETED",
	PENDING = "PENDING",
}

export const MaStatusValues = [
	{
		id: MaStatus.ANNOUNCED,
		title: "Announced",
	},
	{
		id: MaStatus.COMPLETED,
		title: "Completed",
	},
	{
		id: MaStatus.PENDING,
		title: "Pending",
	},
];
